module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"textDialog":"У вас истекло время на тестирование, результаты тестирования переданы работодателю.","close":"Закрыть","left":"Осталось","timeToComplete":"Время для прохождения","minutes":"мин."}}')
  delete Component.options._Ctor
}
